import { render, staticRenderFns } from "./OpportunityPc.vue?vue&type=template&id=16812c64&scoped=true&"
import script from "./OpportunityPc.vue?vue&type=script&lang=js&"
export * from "./OpportunityPc.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityPc.vue?vue&type=style&index=0&id=16812c64&prod&scoped=true&lang=css&"
import style1 from "./OpportunityPc.vue?vue&type=style&index=1&id=16812c64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16812c64",
  null
  
)

export default component.exports